import { useQuery } from '@tanstack/react-query';

import BackendService from '../services/backendService';

const useListAllAiFeedback = ({ gameId }: { gameId: string }) => {
  const scoresCacheKey = ['aiAssessedScores', gameId];
  const { data, isFetching: isFetchingAiAssessedScores } = useQuery({
    queryKey: scoresCacheKey,

    queryFn: async () => {
      const res = await BackendService.instance.game.retrieveAllAIFeedbackForGame({
        gameId,
      });
      return res.items;
    },

    staleTime: 1000 * 60 * 5,
    retry: false
  });

  return {
    aiAssessedScores: data,
    isFetchingAiAssessedScores,
  };
};

export default useListAllAiFeedback;
